import '@fontsource/encode-sans-condensed/400.css';
import '@fontsource/encode-sans-condensed/700.css';
import '@fontsource/league-spartan/400.css';
import '@fontsource/league-spartan/700.css';
import './index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { loadConfig } from './config';
import { strings } from './strings';

const root = createRoot(document.getElementById('root')!);

loadConfig()
  .then((config) =>
    root.render(
      <StrictMode>
        <App config={config} />
      </StrictMode>,
    ),
  )
  .catch((error: unknown) => {
    console.error('Knowledge Base configuration could not be loaded', error);
    root.render(
      <main className="mx-auto max-w-2xl p-8">
        <p role="alert">{strings.errors.config}</p>
      </main>,
    );
  });
